import { ItemTableConsts, ItemTypeConsts } from 'client/util/Constants';

export default {
  methods: {
    inLdapDirectoryAside() {
      return this.panelType === ItemTableConsts.panelType.directoryAsidePanel
        && this.parentType === ItemTypeConsts.ldap;
    },
  },
};
